var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.icon() && _vm.icon().iconType === 'fontawesome' )?_c('i',{class:[_vm.icon().iconName, _vm.iconClass, _vm.size ? 'size-' + _vm.size : '']}):_c('i',{class:[_vm.iconClass, _vm.size ? 'size-' + _vm.size : ''],attrs:{"data-feather":_vm.name}})
}
var staticRenderFns = []

export { render, staticRenderFns }